import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetLaundryRes } from "types/laundry"

import laundriesService from "api/laundriesService"

interface IUseGetLaundryArgs {
  enabled: boolean
  carWashId?: number
}

const useGetLaundry = ({ enabled = false, carWashId }: IUseGetLaundryArgs) => {
  return useQuery("laundry", async () => {
    try {
      const res: AxiosResponse<IGetLaundryRes> = await laundriesService.getLaundry(carWashId)
      return res.data
    }  catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnMount: false, refetchOnWindowFocus: false })
}

export default useGetLaundry